import { render, staticRenderFns } from "./paydetail.vue?vue&type=template&id=1b2cf58f&scoped=true&"
import script from "./paydetail.vue?vue&type=script&lang=js&"
export * from "./paydetail.vue?vue&type=script&lang=js&"
import style0 from "./paydetail.vue?vue&type=style&index=0&id=1b2cf58f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2cf58f",
  null
  
)

export default component.exports